import { Divider, FormField, Heading, ReadOnlyField } from '@msaf/core-react'
import { InputWidth } from '../../../../types/aoraki/input-width-types'
import { WellDrinkingWaterFieldsView } from '../../../../types/form-types'
interface WellDrinkingWaterFieldsEditInterface {
  fields: Partial<WellDrinkingWaterFieldsView>
  isLoading: boolean
}

export default function WellDrinkingWaterView({ fields, isLoading }: WellDrinkingWaterFieldsEditInterface) {
  return (
    <>
      <Heading isSkeleton={isLoading} level={2}>
        Drinking water supply
      </Heading>

      <Heading isSkeleton={isLoading} level={3}>
        Status
      </Heading>

      <FormField isSkeleton={isLoading} label='Supply is active' labelId='supplyIsActive'>
        <ReadOnlyField
          fieldSize={InputWidth.medium}
          isSkeleton={isLoading}
          labelledBy='supplyIsActive'
          value={fields.supplyIsActive}
        />
      </FormField>

      <FormField isSkeleton={isLoading} label='Supply commissioning date' labelId='supplyCommissioningDate'>
        <ReadOnlyField
          fieldSize={InputWidth.medium}
          isSkeleton={isLoading}
          labelledBy='supplyCommissioningDate'
          value={fields.supplyCommissioningDate}
        />
      </FormField>

      <FormField isSkeleton={isLoading} label='Supply decommissioning date' labelId='supplyDecommissioningDate'>
        <ReadOnlyField
          fieldSize={InputWidth.medium}
          isSkeleton={isLoading}
          labelledBy='supplyDecommissioningDate'
          value={fields.supplyDecommissioningDate}
        />
      </FormField>

      <FormField isSkeleton={isLoading} label='Supply type' labelId='authorityCategoryLabel'>
        <ReadOnlyField isSkeleton={isLoading} labelledBy='authorityCategoryLabel' value={fields.authorityCategory} />
      </FormField>

      <Divider />

      <Heading isSkeleton={isLoading} level={3}>
        Taumata Arowai Hinekorako register
      </Heading>

      <FormField isSkeleton={isLoading} label='Registered in Hinekorako' labelId='isSupplyRegisteredWithAuthorityLabel'>
        <ReadOnlyField
          fieldSize={InputWidth.medium}
          isSkeleton={isLoading}
          labelledBy='isSupplyRegisteredWithAuthorityLabel'
          value={fields.isSupplyRegisteredWithAuthority}
        />
      </FormField>

      <FormField isSkeleton={isLoading} label='Supply Owner name' labelId='supplyOwnerNameLabel'>
        <ReadOnlyField isSkeleton={isLoading} labelledBy='supplyOwnerNameLabel' value={fields.supplyOwnerName} />
      </FormField>

      <FormField isSkeleton={isLoading} label='Supply name' labelId='authoritySupplyNameLabel'>
        <ReadOnlyField
          isSkeleton={isLoading}
          labelledBy='authoritySupplyNameLabel'
          value={fields.authoritySupplyName}
        />
      </FormField>

      <FormField isSkeleton={isLoading} label='Supply ID' labelId='authoritySupplyNoLabel'>
        <ReadOnlyField isSkeleton={isLoading} labelledBy='authoritySupplyNoLabel' value={fields.authoritySupplyNo} />
      </FormField>

      <FormField isSkeleton={isLoading} label='Source name' labelId='authoritySourceNameLabel'>
        <ReadOnlyField
          isSkeleton={isLoading}
          labelledBy='authoritySourceNameLabel'
          value={fields.authoritySourceName}
        />
      </FormField>

      <FormField isSkeleton={isLoading} label='Source ID' labelId='authoritySourceNoLabel'>
        <ReadOnlyField isSkeleton={isLoading} labelledBy='authoritySourceNoLabel' value={fields.authoritySourceNo} />
      </FormField>

      <FormField isSkeleton={isLoading} label='Supply population' labelId='authoritySizeLabel'>
        <ReadOnlyField isSkeleton={isLoading} labelledBy='authoritySizeLabel' value={fields.authoritySize} />
      </FormField>

      <Divider />

      <Heading isSkeleton={isLoading} level={3}>
        Verification
      </Heading>

      <FormField isSkeleton={isLoading} label='Verified by' labelId='verifiedBy'>
        <ReadOnlyField isSkeleton={isLoading} labelledBy='verifiedBy' value={fields.verifiedBy} />
      </FormField>

      <FormField isSkeleton={isLoading} label='Verified date' labelId='verifiedDate'>
        <ReadOnlyField
          fieldSize={InputWidth.medium}
          isSkeleton={isLoading}
          labelledBy='verifiedDate'
          value={fields.verifiedDate}
        />
      </FormField>
    </>
  )
}
